import { css } from '@spectrum-web-components/base';
const styles = css`
    :host .spectrum-Table-scroller{z-index:1;position:sticky;inset-block-start:0}:host{display:flex}
`;
export default styles;